// Bridge between the React-tree-bound auth + active-context providers
// and the global error reporter, which is a plain singleton that lives
// outside the React tree (it's installed in main.tsx before any
// component mounts).
//
// AuthProvider + ActiveContextProvider call `setReporterActiveContext`
// from a useEffect whenever the relevant identity bits change, so the
// reporter always has the freshest snapshot to attach to outgoing
// error events.
//
// Reading from this helper is cheap and synchronous; writing is
// cheap and synchronous. Both sides treat the singleton as
// best-effort -- a missed update window means an error is reported
// with a slightly stale userId/orgId, which is fine.

import type { ReporterActiveContext } from '@pc/core';

let snapshot: ReporterActiveContext | null = null;

export function setReporterActiveContext(next: ReporterActiveContext | null): void {
  snapshot = next;
}

export function getActiveContextForReporter(): ReporterActiveContext | null {
  return snapshot;
}
